<template>
  <div class>
    <el-tree
      :props="defaultProps"
      :data="ditree"
      lazy
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
      :load="loadNode"
    ></el-tree>
  </div>
</template>

<script>
import * as pmiDepts from '@/api/pmi/dept';
export default {
  props: {
    typeOne: {
      type: Number,
      default() {
        return null;
      },
    },
    parentIdOne: {
      type: Number,
      default() {
        return 2;
      },
    },
  },
  name: '',
  data() {
    return {
      defaultProps: {
        label: 'label',
        children: 'zones',
        isLeaf: 'leaf',
      },
      ditree: [],
      node: null,
      siShowtree: false,
      node_zero: '', // 将node.level == 0的node存起来
      resolve_zero: '', // 将node.level == 0的resolve存起来
    };
  },

  methods: {
    // 选中某一列
    handleNodeClick(data) {
      this.currentOrgId = data.id;
      this.$emit('childerdepartment', this.currentOrgId, data);
    },
    loadNode(node, resolve) {
      let _this = this;
      _this.node = node; //在data中记录当前node
      if (node.level === 0) {
        let data = {
          isFirst: 1,
          parentId: _this.parentIdOne,
          type: _this.typeOne,
        };
        pmiDepts.getDeptTree(data).then((response) => {
          // debugger
          let tempData = [];
          response.data.forEach(function (item, index) {
            tempData.push({
              label: item.name,
              id: item.id,
              leaf: !item.isNext,
            });
          });
          resolve(tempData);
          // 第一次调用
          _this.getOrgslist();
        });

        // _this.resolve_zero = resolve;
        // _this.node_zero.childNodes = [];
      }
      if (node.level >= 1) {
        _this.parentEventchaild(node.data.id, resolve);
      }
    },

    // 获取左侧部门树形结构
    getOnetree() {
      let _this = this;
      let data = {};
      pmiDepts.getDeptTree(data).then((response) => {
        let tempData = [];
        response.data.forEach(function (item, index) {
          tempData.push({
            label: item.name,
            id: item.id,
            leaf: !item.isNext,
          });
        });
        _this.treelist = tempData;
      });
    },
    // 获取第二级节点数据
    parentEventchaild(parentId, resolve) {
      let _this = this;
      let data = { parentId: parentId, type: _this.typeOne };
      pmiDepts.getDeptTree(data).then((response) => {
        let tempData = [];
        response.data.forEach(function (item, index) {
          tempData.push({
            label: item.name,
            id: item.id,
            leaf: !item.isNext,
          });
        });
        return resolve(tempData);
      });
    },

    // 展开第一层树
    getOrgslist() {
      // 动态加载左侧树结构的耳机菜单
      let nodedata = this.node.childNodes[0];
      nodedata.expanded = true;
      nodedata.loadData();
    },
  },
};
</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.el-select.filter-item.el-select--small {
  width: 100%;
}
</style>
